import React from 'react'
import { isDefinedAndNotNull } from '@scentregroup/shared/lib'
import {
  OnSearchFunc,
  SearchableFacetedFilter,
} from '@scentregroup/shared/hub-components/searchable-faceted-filter'
import { isFacetOptionSelected } from '../../lib/facets'
import { IFacet, IFacetOption, IFacetSelections } from '../../types/facets'
import { onSelectById } from './faceted-filters-utils'
import trackMkpEvents, { labels } from '../../lib/market-place-track-event'
import { groupedFacetOptions } from '../../lib/grouped-facet-options'

interface IFacetedFilter {
  allFacets: IFacet[]
  facet: IFacet
  facetSelections: IFacetSelections
  isLinked?: boolean
  onChangeFacetSelections(facetSelections: IFacetSelections): void
  onSearch?: OnSearchFunc
}

export const FacetedFilter: React.FunctionComponent<
  React.PropsWithChildren<IFacetedFilter>
> = ({
  allFacets,
  facet,
  facetSelections,
  isLinked = false,
  onChangeFacetSelections,
  onSearch,
}) => {
  const { id, title, searchFieldPlaceholder, options } = facet
  const filterOptions = groupedFacetOptions(facet.options, facet.id)

  // the component stores the state so we need to force it to re-render when the options change
  // we do this by using the `key` prop and so it will have a key that matches the available options
  const filterKey = filterOptions
    .map(
      filterOption =>
        `${filterOption.label}-${filterOption.options
          ?.map(option => `${option.label}-${option.value}`)
          .join('')}`
    )
    .join('')

  return (
    <SearchableFacetedFilter
      key={filterKey}
      id={id}
      title={title}
      isLinked={isLinked}
      searchFieldPlaceholder={
        isDefinedAndNotNull(searchFieldPlaceholder)
          ? searchFieldPlaceholder
          : undefined
      }
      optionGroups={filterOptions}
      isSearchable={!!searchFieldPlaceholder}
      selectedOptions={options
        ?.filter((option: IFacetOption) =>
          isFacetOptionSelected(facetSelections, id, option.id)
        )
        .map((option: IFacetOption) => option.id)}
      onChange={(
        selection: string[],
        { option, isChecked }: { isChecked: boolean; option: string }
      ) => {
        onSelectById(
          id,
          selection,
          allFacets,
          facetSelections,
          onChangeFacetSelections
        )
        if (isChecked) {
          trackMkpEvents.selected(
            labels.createSelectedFilterFacet(title, option)
          )
        } else {
          trackMkpEvents.unselected(
            labels.createSelectedFilterFacet(title, option)
          )
        }
      }}
      onSearch={onSearch}
    />
  )
}

export default FacetedFilter
